import {Box, Flex, Stack, Text} from '@chakra-ui/core';
import Loader from 'components/Loader';
import {useStateMachine} from 'little-state-machine';
import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {updateForm, updateCalculatedValues} from 'store';
import {parseNumber} from 'utils/fields';
import {formFields} from 'constants/formValues';
import {recalculateValues} from 'views/Calculator/calculateValues';
import {displayValues} from 'constants/dataDisplayValues';
import SidebarSettings from 'components/SidebarSettings';
import RecommendedModel from 'components/recommendedModel';
import ModelDetailsTable from 'components/ModelDetailsTable';
import {yellow} from 'styles/constants';
import sleipnerLogo from 'assets/logo.svg';

export const SleipnerSlogan = () => {
	return (
		<Flex alignItems={'flex-end'}>
			<img
				style={{display: 'inline-block'}}
				src={sleipnerLogo}
				alt="Sleipner"
				width={'60px'}
			/>
			<Text ml={4} color={yellow} fontWeight="bold" fontSize={'20px'}>
				Wheels of change.
			</Text>
		</Flex>
	);
};

const getWarnings = (formValues) => {
	const warnings = {};

	if (formValues['estimatedMachineLifetime'] < formValues['undercarriageLifetime(h)']) {
		warnings['undercarriageLifetime(h)'] =
			'Undercarriage lifetime is longer than estimated machine lifetime!';
	}

	// No warnings
	return warnings;
};

export const Step2 = (props) => {
	const {recommendedSleipner, setCurrentView, setDataForCharts} = props;
	const {actions} = useStateMachine({updateForm, updateCalculatedValues});
	const [calculatedValues, setCalculatedValues] = useState({});
	const [settingsOpen, setSettingsOpen] = useState(false);
	const [warnings, setWarnings] = useState({});

	let defaultFormValues = {};

	formFields.forEach((f) => {
		defaultFormValues[f] = recommendedSleipner[f] ?? '';
	});

	useEffect(() => {
		const values = recalculateValues(getValues(), recommendedSleipner);
		setCalculatedValues(values);
	}, []);

	useEffect(() => {
		if (Object.keys(calculatedValues).length > 0) {
			setDataForCharts({calculatedValues, recommendedSleipner});
		}
	}, [calculatedValues]);

	const {register, handleSubmit, getValues, setValue} = useForm({
		defaultValues: defaultFormValues,
	});

	// Move to summary
	const onSubmit = (data) => {};

	const handleOnChange = (data) => {
		recalc();
	};

	const moveToSummary = (data) => {
		recalc();
		setCurrentView(3);
	};

	function recalc() {
		const formValues = getValues();

		setWarnings(getWarnings(formValues));

		// save inputted values to store for later use after refresh
		actions.updateForm(formValues);

		// Recalculate values based on new form values
		const calculatedValues = recalculateValues(formValues, recommendedSleipner);
		setCalculatedValues(calculatedValues);

		// Set calculated values to store for later use in other stages
		actions.updateCalculatedValues(calculatedValues);
	}

	if (!recommendedSleipner) return <Loader />;

	return (
		<Box margin="auto" p={4} rounded={4} maxW="1400px" mx="auto">
			<Flex direction={{base: 'column', lg: 'row'}}>
				<Stack w={{base: '100%', lg: '33%'}} justifyContent={'space-between'}>
					<Box>
						{settingsOpen && (
							<SidebarSettings
								handleSubmit={() => handleSubmit(onSubmit)}
								formFields={formFields}
								displayValues={displayValues}
								defaults={defaultFormValues}
								handleOnChange={handleOnChange}
								register={register}
								parseNumber={parseNumber}
								setSettingsOpen={setSettingsOpen}
								setValue={setValue}
								getValues={getValues}
								warnings={warnings}
							/>
						)}
						{!settingsOpen && (
							<RecommendedModel
								moveToSummary={moveToSummary}
								setSettingsOpen={setSettingsOpen}
								recommendedSleipner={recommendedSleipner}
							/>
						)}
					</Box>

					<Box display={{base: 'none', lg: 'flex'}}>
						<SleipnerSlogan />
					</Box>
				</Stack>

				<ModelDetailsTable calculatedValues={calculatedValues} />

				<Box display={{base: 'flex', lg: 'none'}} mt={5}>
					<SleipnerSlogan />
				</Box>
			</Flex>
		</Box>
	);
};
